import type { SegcenFormat } from "@/interfaces/AccessControl";
import { RequirementRow } from "@/interfaces/requirements";
import { validateSegcenPermissions } from "@/utils/accessControlUser";
import { getEnvironmentVariable } from "@/utils/environment";

export const getPermissionRequirementMedical = (actionCode: string, segcen: SegcenFormat): boolean => {
  return validateSegcenPermissions({
    segcen,
    object: getEnvironmentVariable('VITE_APP_SEGCEM_HOME_EXECUTIVE_TAXRELIEF'),
    action: actionCode
  });
}

export const getPermissionDetailEvaluateRelief = (actionCode: string, segcen: SegcenFormat): boolean => {
  return validateSegcenPermissions({
    segcen,
    object: getEnvironmentVariable('VITE_APP_SEGCEM_DETAIL_EVALUATE_RELIEF'),
    action: actionCode
  });
}

export const extractRequirementId = (recordIdCompose: string): number => {
  const id = Number(recordIdCompose.split('-')[1]);
  if (isNaN(id)) throw new Error('Invalid ID');
  return id;
};

export const getSelectedRequirementIds = (
  selectedRequirements: Record<number, RequirementRow[]>,
  insuredId: number | null
): number[] => {
  if (!insuredId || !selectedRequirements[insuredId]?.length) return [];
  return selectedRequirements[insuredId].map(req => 
    extractRequirementId(req.idRecord)
  );
};